import { lazy } from 'react';

export default {
  'app/pages/common/landing/Landing': lazy(() => import('app/pages/common/landing/Landing')),
  'app/pages/common/findALocation/FindALocation': lazy(() => import('app/pages/common/findALocation/FindALocation')),
  'app/pages/common/interpreterService/InterpreterService': lazy(
    () => import('app/pages/common/interpreterService/InterpreterService'),
  ),
  'app/pages/common/userDetails/UserDetails': lazy(() => import('app/pages/common/userDetails/UserDetails')),
  'app/pages/common/rjsf/RJSF': lazy(() => import('app/pages/common/rjsf/RJSF')),
  'app/pages/common/reviewDetails/ReviewDetails': lazy(() => import('app/pages/common/reviewDetails/ReviewDetails')),
  'app/pages/common/confirmation/Confirmation': lazy(() => import('app/pages/common/confirmation/Confirmation')),
  'app/pages/common/businessDetails/BusinessDetails': lazy(
    () => import('app/pages/common/businessDetails/BusinessDetails'),
  ),
  'app/pages/common/sbaBusinessDetails/SbaBusinessDetails': lazy(
    () => import('app/pages/common/sbaBusinessDetails/SbaBusinessDetails'),
  ),
  'app/pages/common/sbaConfirmation/SbaConfirmation': lazy(
    () => import('app/pages/common/sbaConfirmation/SbaConfirmation'),
  ),
};
